import { IFeeInSale } from "../types/types";
import { toFixed } from "./number.utils";

export function processFees(total: number, fees: IFeeInSale[]): number {
  return total + processFeesOnly(total, fees);
}

/**
 * Amount a single fee adds to the bill, for displaying a fee line by itself.
 * A PERCENT fee is charged off the given total, a FLAT fee is charged as is.
 */
export function processFee(total: number, fee: IFeeInSale): number {
  if (fee.type === "PERCENT") {
    return toFixed((fee.value / 100) * total);
  }
  return fee.value;
}

export function processFeesOnly(total: number, fees: IFeeInSale[]): number {
  // IMPORTANT: the fees should be calculated off the original total and not cummulative total.

  const flatFeeTotal = fees
    .filter((f) => f.type === "FLAT")
    .reduce((acc, curr) => {
      return acc + curr.value;
    }, 0);

  const percentFeeTotal = fees
    .filter((f) => f.type === "PERCENT")
    .reduce((acc, curr) => {
      return acc + toFixed((curr.value / 100) * total);
    }, 0);

  return flatFeeTotal + percentFeeTotal;
}
